import useConfirmationSubmit from '../hooks/useConfirmationSubmit';
import '../CSS/pages.css';

function DispatchService() {
  const { handleSubmit, isSubmitting, submitError } = useConfirmationSubmit(
    'carrierDispatch',
    'carrier dispatch support'
  );

  return (
    <main className="page service-page">
      <section className="page-heading">
        <p className="eyebrow">Carrier dispatch support</p>
        <h1>Dispatch support for growing carrier operations.</h1>
        <p>
          Keep your drivers, freight details, broker communication, and weekly
          planning aligned with dispatch support built for active carriers.
        </p>
      </section>

      <section className="split-section">
        <div>
          <h2>Built around the way your operation runs.</h2>
          <p>
            Share your equipment, preferred lanes, weekly availability, and
            dispatch goals so the proposal can be shaped around your actual
            freight needs.
          </p>
        </div>
        <ul className="feature-list">
          <li>Freight planning support</li>
          <li>Broker communication coordination</li>
          <li>Pickup and delivery detail tracking</li>
          <li>Route and availability awareness</li>
        </ul>
      </section>

      <section className="form-section">
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            Company name
            <input type="text" name="companyName" placeholder="Company name" required />
          </label>
          <label>
            USDOT number
            <input type="text" name="usdotNumber" placeholder="USDOT number" required />
          </label>
          <label>
            Email
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              autoComplete="email"
              required
            />
          </label>
          <label>
            Phone number
            <input type="tel" name="phone" placeholder="(555) 000-0000" required />
          </label>
          <label>
            Message
            <textarea
              name="message"
              rows="5"
              placeholder="Tell us about your fleet, lanes, and dispatch needs"
              required
            />
          </label>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Request dispatch support'}
          </button>
          {submitError && <p className="form-error">{submitError}</p>}
        </form>
      </section>
    </main>
  );
}

export default DispatchService;
